import request from '../../../shared/request'

export function getJobInvoices(job_id) {
  return request(`/job/job_invoices/${job_id}/`)
}

export function getDashboardInvoices(assignetToId) {
  return request(`/dashboard/invoices/${assignetToId}/`)
}

export function createJobInvoice(payload) {
  return request(`/job/job_invoices/${payload.job_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateJobInvoice(payload) {
  return request(`/job/job_invoices/${payload.job_invoice_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteJobInvoice(payload) {
  return request(`/job/job_invoices/${payload.job_invoice_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function uploadAttachments(payload) {
  return request(`/job/job_invoices/${payload.invoiceId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getAttachments(invoiceId) {
  return request(`/job/job_invoices/${invoiceId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/job/job_invoices/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteAttachment(payload) {
  return request(`/job/job_invoices/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/invoices.js